import { createFileRoute } from '@tanstack/react-router';
import { FrameworkContractPage } from '@/pages/contract/framework-contract/framework-contract-page.tsx';

export const Route = createFileRoute('/_auth/rahmenvertrag/')({
  component: FrameworkContractPage,
  staticData: { title: 'Rahmenvertrag' },
});
